import React, { useState, useEffect } from "react";
import HomePortfolioMobile from "components/Section/HomePortfolio/HomePortfolioMobile";
import HomeTalentMobile from "components/Section/HomeTalent/HomeTalentMobile";
import HomePortfolioDesktop from "components/Section/HomePortfolio/HomePortfolioDesktop";
import HomeTalentDesktop from "components/Section/HomeTalent/HomeTalentDesktop";
import { MAX_RESPONSIVE_MOBILE } from "store/constants";
import withDimension from "utils/withDimension";
import portfolio from "data/Home/portfolio.json";
import { getTalents, getPortfolios } from "services/Homepage";

const HomeMultipleSection = (props) => {
  const [talentList, setTalentList] = useState(null);
  const [portfolioList, setPortfolioList] = useState(null);

  async function fetchTalents() {
    const result = await getTalents();

    setTalentList(result);
  }

  async function fetchPortfolios() {
    const result = await getPortfolios();

    setPortfolioList(result);
  }

  useEffect(() => {
    fetchTalents();
    fetchPortfolios();
  }, []);

  return (
    <>
      {props.windowDimension.width <= MAX_RESPONSIVE_MOBILE ? (
        <>
          <HomeTalentMobile talents={talentList} />
        </>
      ) : (
        <>
          <HomeTalentDesktop talents={talentList} />
        </>
      )}

      {props.windowDimension.width <= MAX_RESPONSIVE_MOBILE ? (
        <>
          <HomePortfolioMobile portfolio={portfolioList} />
        </>
      ) : (
        <>
          <HomePortfolioDesktop portfolio={portfolioList} />
        </>
      )}
    </>
  );
};

export default withDimension(HomeMultipleSection);
